import {
  Trophy,
  Crown,
  Users,
  ShieldCheck,
  UsersRound,
  FileText,
  Award,
  CalendarDays,
  Phone,
  Menu,
  X,
  ArrowLeft,
  ChevronLeft,
  ChevronDown,
  Volleyball,
  Newspaper,
  Medal,
  CalendarClock,
  CheckCircle2,
  PlayCircle,
  LogIn,
  LogOut,
  Circle,
  LayoutDashboard,
  Wallet,
  Ticket,
  Settings,
  Pencil,
  Trash2,
  Plus,
  Search,
  Bell,
  UserCircle,
  Building2,
  Megaphone,
  BarChart3,
  Clock,
  MapPin,
  Filter,
  Eye,
  Check,
  AlertTriangle,
  Loader2,
  Play, 
  Pause,
} from "lucide-react";
import { FaInstagram, FaTelegramPlane } from "react-icons/fa";
import { cn } from "../../lib/utils";

const ICONS = {
  instagram: FaInstagram,
  telegram: FaTelegramPlane,
  trophy: Trophy,
  crown: Crown,
  users: Users,
  shield: ShieldCheck,
  userGroup: UsersRound,
  document: FileText,
  award: Award,
  calendar: CalendarDays,
  phone: Phone,
  menu: Menu,
  close: X,
  arrowLeft: ArrowLeft,
  chevronLeft: ChevronLeft,
  chevronDown: ChevronDown,
  ball: Volleyball,
  news: Newspaper,
  competition: Medal,
  schedule: CalendarClock,
  check: CheckCircle2,
  play: PlayCircle,
  logIn: LogIn,
  logOut: LogOut,
  dashboard: LayoutDashboard,
  wallet: Wallet,
  ticket: Ticket,
  settings: Settings,
  edit: Pencil,
  trash: Trash2,
  plus: Plus,
  search: Search,
  bell: Bell,
  userCircle: UserCircle,
  club: Building2,
  ad: Megaphone,
  report: BarChart3,
  clock: Clock,
  location: MapPin,
  filter: Filter,
  eye: Eye,
  checkSimple: Check,
  warning: AlertTriangle,
  spinner: Loader2,
  competition: Medal,
  medal: Medal,
  schedule: CalendarClock,
  play: Play,
  pause: Pause,
};

function Icon({ name, className, ...props }) {
  const Component = ICONS[name] || Circle;
  return <Component className={cn("h-5 w-5", className)} {...props} />;
}

export default Icon;
